// /my — «Мои задачи» (030: T029; FR-019 – FR-031, FR-042; ASG-DESK-01): пункты всех протоколов,
// где человек пользователя среди ответственных. Право — items.own (связь учётной записи
// с человеком; без связи сервер ответит ACC-008 — экран покажет причину). Условия — в адресе:
// /my?view=done — «Выполненные», /my?group=overdue — группа срока из «Главной» (myItemsHref).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { MyItemsPage } from '../../features/my-items/MyItemsPage.tsx';
import { parseMySearch } from '../../features/my-items/data.ts';
import type { MySearch } from '../../features/my-items/data.ts';

export const Route = createFileRoute('/_app/my')({
  validateSearch: parseMySearch,
  staticData: { crumb: 'Мои задачи' },
  component: MyRoute,
});

function MyRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: MySearch) => void navigate({ to: '/my', search: next, replace: true }),
    [navigate],
  );
  return <MyItemsPage search={search} onSearchChange={onSearchChange} />;
}
